// The app's springs, named for what they move. Tuned against ObsidianUI's
// dashboard shell, whose feel the sidebar and tabs copy.
//
// Reduced motion is handled once, by `<MotionConfig reducedMotion="user">` in
// the shell: with it set, layout and transform animations jump into place.

/** The hover highlight, gliding after the pointer. */
export const FOLLOW_SPRING = { type: 'spring', stiffness: 650, damping: 45, mass: 0.5 } as const

/** The active pill, sliding to the chosen item. */
export const PILL_SPRING = { type: 'spring', stiffness: 520, damping: 38, mass: 0.7 } as const

/** A sidebar folder unfolding to its height, or folding away. */
export const FOLD_SPRING = { type: 'spring', stiffness: 420, damping: 40, mass: 0.8 } as const
